/** Root cache key for every per-target sentiment entry. */
export const SENTIMENT_CACHE_KEY = 'community-sentiment';

/** `feedbackType` values. Only `reaction` is read by the rating control. */
export const SENTIMENT_FEEDBACK_TYPE = {
    REACTION: 'reaction',
    REVIEW: 'review',
} as const;

/** `targetType` values this store supports. */
export const SENTIMENT_TARGET_TYPE = {
    SHOW: 'show',
    MOVIE: 'movie',
} as const;

export type SentimentTargetType =
    (typeof SENTIMENT_TARGET_TYPE)[keyof typeof SENTIMENT_TARGET_TYPE];

export const SENTIMENT_REACTION = {
    LOVE: 'love',
    HILARIOUS: 'hilarious',
    THUMBS_UP: 'thumbs_up',
    THUMBS_DOWN: 'thumbs_down',
    POPCORN: 'popcorn',
} as const;

export const MAX_SENTIMENT_BATCH_SIZE = 50;

export const SENTIMENT_WRITES_ARE_OPTIMISTIC = true;

/** Blueprint key read by `useAllowSentimentControls`. */
export const SENTIMENT_CONFIG_KEY = 'communitySentiment';
